import { securedAxiosInstance } from "../axios";

class ClaimDeclarationsService {
  show(declarationId) {
    return securedAxiosInstance.get(`/claims_declaration/${declarationId}`);
  }

  createNewVersion(claimDeclarationId) {
    return securedAxiosInstance.post(`/claims_declaration/${claimDeclarationId}/new_version`);
  }

  update(declarationId, formData, signal) {
    return securedAxiosInstance.put(`/claims_declaration/${declarationId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      signal,
    });
  }

  retryAiAnalysis(declarationId, analysisType) {
    return securedAxiosInstance.post(`/claims_declaration/${declarationId}/retry_ai_analysis`, {
      analysis_type: analysisType,
    });
  }
}

export default new ClaimDeclarationsService();
